import React from 'react';

import { userService } from '../UserService';
import { translate } from "react-i18next";
import { Card, Row, Col, Alert } from 'react-bootstrap';
import { GREY_LIGHT } from '../../backend/Colors';
import { sendJson } from '../../backend/Backend';

class PasswordForgotten extends React.Component {
    constructor(props) {
        super(props);

        userService.logout();

        this.state = {
            username: '',
            send: false,
            loading: false,
            message: '',
            submitted: false
        };

        this.handleChange = this.handleChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
    }

    handleChange(e) {
        const { name, value } = e.target;
        this.setState({ [name]: value });
    }

    handleSubmit(e) {
        e.preventDefault();

        this.setState({ submitted: true });
        const { username } = this.state;

        // stop here if form is invalid
        if (!(username)) {
            return;
        }

        this.setState({ loading: true });

        let user = { "email": this.state.username };
        sendJson('post', 'users/pwdForgotten', user).then(
            received => {
               if (received.ok) {
                    this.setState({ loading: false, message: 'pwdSend', send:'true' });
                    // store user details and basic auth credentials in local storage 
                    // to keep user logged in between page refreshes
                    //user.authdata = window.btoa(username + ':' + password);
                    //localStorage.setItem('user', JSON.stringify(received));
                } else {
                    this.setState({ loading: false, message: 'emailNotExist' });
                }
            });

    }

    inputValid() {
        return this.state.username;
    }

    render() {
        const { t } = this.props;
        const { username, submitted, loading, message } = this.state;
        return (

            <Card style={{ "background": GREY_LIGHT }}>
                <Card.Header className="text-primary"><h4>{t("passwordForgotten")+this.state.message}</h4></Card.Header>
                <Card.Body>
                    {this.state.message ?
                        <div>
                            <Row>
                                <Col>
                                    <Alert  variant={this.state.send ? 'success':'danger'}>
                                        {t(message)}
                                    </Alert>
                                </Col>
                            </Row>
                        </div>
                        :
                        ''
                    }

                    <form name="form" onSubmit={this.handleSubmit}>
                        <div className={'form-group' + (submitted && !username ? ' has-error' : '')}>
                            <input type="text" className="form-control" name="username" value={username} onChange={this.handleChange} placeholder={t("E-Mail")} 
                             maxLength={250}/>
                            {submitted && !username &&
                                <div className="help-block">{t("UsernameRequired")}</div>
                            }
                        </div>
                        <div className="form-group">
                            <button className="btn btn-primary float-right" disabled={loading || !this.inputValid()}>{t("sent")}</button>
                            {loading &&
                                <img alt="Loading..." src="data:image/gif;base64,R0lGODlhEAAQAPIAAP///wAAAMLCwkJCQgAAAGJiYoKCgpKSkiH/C05FVFNDQVBFMi4wAwEAAAAh/hpDcmVhdGVkIHdpdGggYWpheGxvYWQuaW5mbwAh+QQJCgAAACwAAAAAEAAQAAADMwi63P4wyklrE2MIOggZnAdOmGYJRbExwroUmcG2LmDEwnHQLVsYOd2mBzkYDAdKa+dIAAAh+QQJCgAAACwAAAAAEAAQAAADNAi63P5OjCEgG4QMu7DmikRxQlFUYDEZIGBMRVsaqHwctXXf7WEYB4Ag1xjihkMZsiUkKhIAIfkECQoAAAAsAAAAABAAEAAAAzYIujIjK8pByJDMlFYvBoVjHA70GU7xSUJhmKtwHPAKzLO9HMaoKwJZ7Rf8AYPDDzKpZBqfvwQAIfkECQoAAAAsAAAAABAAEAAAAzMIumIlK8oyhpHsnFZfhYumCYUhDAQxRIdhHBGqRoKw0R8DYlJd8z0fMDgsGo/IpHI5TAAAIfkECQoAAAAsAAAAABAAEAAAAzIIunInK0rnZBTwGPNMgQwmdsNgXGJUlIWEuR5oWUIpz8pAEAMe6TwfwyYsGo/IpFKSAAAh+QQJCgAAACwAAAAAEAAQAAADMwi6IMKQORfjdOe82p4wGccc4CEuQradylesojEMBgsUc2G7sDX3lQGBMLAJibufbSlKAAAh+QQJCgAAACwAAAAAEAAQAAADMgi63P7wCRHZnFVdmgHu2nFwlWCI3WGc3TSWhUFGxTAUkGCbtgENBMJAEJsxgMLWzpEAACH5BAkKAAAALAAAAAAQABAAAAMyCLrc/jDKSatlQtScKdceCAjDII7HcQ4EMTCpyrCuUBjCYRgHVtqlAiB1YhiCnlsRkAAAOwAAAAAAAAAAAA==" />
                            }
                        </div>
                     
                    </form>

                </Card.Body>
            </Card>

        );
    }
}

export default translate("translations")(PasswordForgotten);